import React, { FunctionComponent, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import Staff from 'model/Staff';
import StaffComponent from './StaffComponent';

interface Props {
    selectedStaff?: number;
    onSelectStaff: (staffId?: number, first?: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingBottom: 18,
            [theme.breakpoints.up('md')]: {
                paddingBottom: 20
            }
        },
        title: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '16px',
            marginBottom: 18,
            [theme.breakpoints.up('md')]: {
                marginBottom: 20
            }
        }
    })
);

export const ExtraStaffSelector: FunctionComponent<Props> = props => {
    const classes = useStyles(props);

    const [staffSelected, setStaffSelected] = useState<Staff | undefined>();

    const allActiveStaff = useSelector<RootState, Array<Staff>>(state => state.staff.staff).filter(
        member => member.active && !member.deleted
    );

    useEffect(() => {
        setStaffSelected(allActiveStaff.find(staff => props.selectedStaff === staff.id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedStaff]);

    return (
        <Box className={classes.container}>
            <StaffComponent
                selectedOption={staffSelected}
                options={allActiveStaff}
                onSelectStaff={(staff: Staff) => props.onSelectStaff(staff?.id, true)}
            />
        </Box>
    );
};

export default ExtraStaffSelector;
